import { Button, DataSource, Label, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutTemporaryLicenseRevoke extends Layout {
    buttonSave: Button;
    labelInstructions: Label;
    labelNotesListHeader: Label;
    layoutheaderTLR: LayoutHeader;
    sourceLicenses: DataSource;
    tableLicenses: Table;
}
